export interface Special {
  id: string;
  title: string;
  subtitle: string;
  description: string;
  cover: string;
  type: string;
  filter: string;
  accent: string;
}

export const specials: Special[] = [
  {
    id: "sp-classic",
    title: "经典伦理电影精选",
    subtitle: "沉淀时光的九部佳作",
    description:
      "从家庭到都市，从克制到炽烈，收录一批被反复回味的韩国伦理电影代表作，带你重新读懂人性的灰度。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20collage%20of%20classic%20Korean%20drama%20film%20scenes%2C%20deep%20navy%20blue%20and%20warm%20amber%20grading%2C%20moody%20artistic%20film%20grain%20texture%2C%20elegant%20editorial%20composition%2C%20no%20text&width=800&height=600&seq=krfilm-sp01&orientation=landscape",
    type: "movie",
    filter: "伦理情感",
    accent: "经典",
  },
  {
    id: "sp-yearly",
    title: "年度热门伦理剧集",
    subtitle: "本季讨论度最高的韩剧",
    description:
      "集结当下最受关注的伦理题材电视剧，从家庭群像到都市悬疑，一次看过瘾，追剧不再选择困难。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20scene%20of%20modern%20Seoul%20apartment%20rooftop%20at%20dusk%2C%20deep%20navy%20blue%20with%20warm%20amber%20lights%2C%20trendy%20dramatic%20film%20grain%20texture%2C%20editorial%20composition%2C%20no%20text&width=800&height=600&seq=krfilm-sp02&orientation=landscape",
    type: "tvseries",
    filter: "都市伦理",
    accent: "热播",
  },
  {
    id: "sp-suspense",
    title: "伦理悬疑特辑",
    subtitle: "真相藏在每一个细节里",
    description:
      "当伦理关系遇上缜密推理，每一个看似平静的家庭都可能藏着秘密。适合喜欢烧脑与情绪张力的观众。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20mystery%20scene%2C%20dim%20corridor%20with%20a%20single%20glowing%20door%20and%20long%20shadows%2C%20cold%20navy%20blue%20and%20amber%20grading%2C%20tense%20film%20grain%20texture%2C%20elegant%20composition%2C%20no%20text&width=800&height=600&seq=krfilm-sp03&orientation=landscape",
    type: "movie",
    filter: "伦理悬疑",
    accent: "烧脑",
  },
  {
    id: "sp-family",
    title: "家庭伦理情感长廊",
    subtitle: "屋檐之下的爱与亏欠",
    description:
      "聚焦代际关系与家庭羁绊，收录最动人的家庭伦理作品，讲述那些说不出口却始终存在的牵挂。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20warm%20family%20dinner%20table%20scene%20seen%20from%20above%2C%20soft%20sepia%20and%20navy%20grading%2C%20intimate%20film%20grain%20texture%2C%20elegant%20editorial%20composition%2C%20no%20text&width=800&height=600&seq=krfilm-sp04&orientation=landscape",
    type: "tvseries",
    filter: "家庭伦理",
    accent: "温情",
  },
  {
    id: "sp-love",
    title: "都市爱情伦理合集",
    subtitle: "在城市里相遇又走散",
    description:
      "霓虹与雨夜，错过与重逢。精选都市爱情伦理题材，献给所有在城市里认真爱过的人。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20romantic%20city%20scene%20at%20rainy%20night%20with%20bokeh%20lights%20and%20reflections%2C%20deep%20navy%20blue%20and%20warm%20orange%20grading%2C%20dreamy%20film%20grain%20texture%2C%20no%20text&width=800&height=600&seq=krfilm-sp05&orientation=landscape",
    type: "movie",
    filter: "爱情伦理",
    accent: "浪漫",
  },
  {
    id: "sp-revenge",
    title: "复仇与救赎",
    subtitle: "命运翻盘的高能时刻",
    description:
      "被逼到绝境的人生如何逆流而上，收录复仇伦理题材的爽感与深刻，看角色在灰度中找回尊严。",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20abstract%20dramatic%20scene%2C%20lone%20figure%20standing%20before%20towering%20city%20glass%20towers%20at%20night%2C%20deep%20navy%20blue%20and%20bold%20warm%20orange%20grading%2C%20film%20grain%20texture%2C%20no%20text&width=800&height=600&seq=krfilm-sp06&orientation=landscape",
    type: "tvseries",
    filter: "复仇伦理",
    accent: "高能",
  },
];